
function fnNews(){
	$('.snav[data-page="news__index"] ul li a').on('click', function(e){
		e.preventDefault();
		var select = $(this).parent()[0].getAttribute('data-select');
		$('.snav[data-page="news__index"] ul')[0].setAttribute('data-select', select);
		$('.container[data-page="news__index"] .pagenav ul')[0].setAttribute('data-select', select);
		$('.container[data-page="news__index"] .pagenav ul')[0].setAttribute('data-sort', "");
		$('.container[data-page="news__index"] .news--list')[0].setAttribute('data-sort', "ALL");
	});
	$('.container[data-page="news__index"] .pagenav li a').on('click', function(e){
		e.preventDefault();
		var sort = $(this).parent()[0].getAttribute('data-sort');
		$('.container[data-page="news__index"] .pagenav ul')[0].setAttribute('data-sort', sort);
		$('.container[data-page="news__index"] .news--list')[0].setAttribute('data-sort', sort);
	});

	$('.accordion').on('click', function(e){
		e.preventDefault();
		$(this).toggleClass('is--close');
		$(this).next('.accordion__ul').toggleClass('is--close');
	});
}
module.exports = fnNews;



// WEBPACK FOOTER //
// ./es2015/_news.js